import React from 'react';
import Counter from './Counter';

export default function HomeAbout(props) {
const AboutColumns = [
  {
    id: 1,
    src: "about1.png",
    end: 6,
    description: "YEARS OF EXPERIENCE",
  },
  {
    id: 2,
    src: "about2.png",
    end: 10,
    description: "ADMIN DASHBOARDS & PROJECTS",
  },
  {
    id: 3,
    src: "about3.png",
    end: 18,
    description: "LIVE ENTERPRISE WEBSITES",
  },
  {
    id: 4,
    src: "about4.png",
    end: 5,
    description: "ACTIVE PROJECTS DELIVERED",
  },
];

  return (
    <>
      <section className="aboutSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="aboutHeadings text-center">
                <h2>{props.aboutHeading}</h2>
                <h4 className='brandText'>{props.aboutSubHeading}</h4>
              </div>
              <div className="aboutHeadingPara">
                <p className='mb-0 mt-4'>{props.aboutPara1}</p>
                <p className='mb-0 mt-4'>{props.aboutPara2}</p>
     <p className='mb-0 mt-4'>{props.aboutPara3}</p>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            {AboutColumns.map((aboutColumn) => (
              <div className="col-md-3 mb-4" key={aboutColumn.id}>
                <div className="aboutColumns text-center">
                  <div data-aos="fade-down" data-aos-easing="ease-out-cubic"
     data-aos-duration="1000" data-aos-delay="200" className="aboutColumnImage">
                    <img src={aboutColumn.src} alt="" className="img-fluid" />
                  </div>
                  <Counter end={aboutColumn.end} description={aboutColumn.description} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
